import React, { useContext, useEffect, useState } from "react";
import { Link } from "gatsby";
import Footer from "~components/Footer";
import Layout from "~components/Layout";
import SEO from "~components/SEO";
import { AppContext } from "~context/AppContext.jsx";

const FAQsPage = () => {
  const {
    activeCurrencySymbol
  } = useContext(AppContext);
  var freeShipping = 60;
  if (process.env.GATSBY_REGION_CODE.toLowerCase() == `uk`) {
    freeShipping = 50;
  }
  return (
    <>
      <SEO
        customTitle="FAQs"
        customDescription="FAQs page"
        customKeywords="FAQ"
        path="/faqs"
      />

      <Layout className="faqs w-full relative">
        <section className="faqs__container grid">
          <div className="animation-appear-left-slow animation-delay-3 grid-end-5 xs:grid-end-12 grid-start-2 xs:grid-start-1 h-screen xs:h-auto sticky xs:relative top-0 xs:top-auto left-0 xs:left-auto pt-v6 xs:pt-24">
                    <h1 className="f3">FAQs</h1>
                </div>
          <div
                  className="terms-page__content animation-appear-right-slow animation-delay-3 grid-end-4 xs:grid-end-12 grid-start-7 xs:grid-start-1 pt-v6 xs:pt-8 whitespace-pre-wrap">
          <h4>Will my socks stretch or shrink?</h4>

      <p>Merino fibres have an internal spring-like coil that holds the fibre’s shape; that means they’re naturally resilient and stretchy fibre. You can stretch it to 20% of its length it will bounce right back to the original. In fact, you can clean them in a washing machine without them shrinking. Follow our simple&nbsp;
        <Link
          to="/care-instructions"
          className="underline"
        >
          care tips
        </Link>
        .
      </p>


      <h4>Are Paire socks machine-washable?</h4>

      <p>Absolutely. Just remember to turn your socks inside-out. Keep the water temperature cool or warm. No fabric softeners. And air-drying is recommended. You can find our full care guide&nbsp;
        <Link
          to="/care-instructions"
          className="underline"
        >
          here
        </Link>
        .
      </p>


      <h4>What is your return policy?</h4>

      <p>We want you to feel good wearing your Paire as we are designing them. That's why we cover free returns (including free shipping) within 30 days of purchase. If you'd like to return your Paire, please reach out to us.</p>


      <h4>What if I want to cancel or change my order?</h4>

      <p>Most orders ship within 1-2 business days of being placed; that said, please email us at team@paire.com.au and we’ll see what we can do! If you’re just getting cold feet, hang on until you can give them a try–we think you’ll love them and if you don’t, you can always send them back for free within 30 days of purchase.</p>


      <h4>How do you ship?</h4>

      <p>We’ll foot the bill on domestic shipping for orders over {activeCurrencySymbol}{freeShipping}. Free international shipping on orders over {activeCurrencySymbol}100.</p>


      <h4>Where can I buy Paire at a brick and mortar location?</h4>

      <p>One of our secrets to keeping our pricepoint desirable is by operating completely online. At this stage, Paire products are only available via our website. But hey, you get 30-days no-question free return.</p>


      <h4>What’s CoolBlend?</h4>

      <p>It’s the goldilocks of cotton and wool aka CoolBlend. Together, they bring you comfort. Separately, they have their own powers. Wool is used for climate-control, deodorisation, warmth and softness. The Merino variety is also antimicrobial, so germs will never call your socks home. Cotton is used to absorb sweat. It keeps skin sensitivities at an all-time low. It’s soft and durable. And organic. This means that no chemicals are used in the farming process, so the fabric is better for our pickers, the planet and your toes.</p>


      <h4>What’s the difference between short Merino and long Merino?</h4>

      <p>Not all Merino carries the properties we’ve talked about above. Top-of-the-range Merino has a longer fibre which means it’s warm in the cold and cool in the heat. Sheep are quite magnificent.</p>


      <h4>Aren’t Merino products usually quite expensive?</h4>

      <p>Good observation. You’re right. We’ve managed to keep our quality high and make the price point desirable too. How? Paire is vertically integrated so we own the entire supply chain. The only corners we cut are at 90 degrees – just like your foot.</p>


      <h4>Will there be pilling with Merino wool?</h4>

      <p>Pilling is natural with delicate fibres like Merino wool. In fact, it’s the sign of an intricately woven, quality product.</p>


      <h4>Were any sheep harmed in the making of Paire?</h4>

      <p>Absolutely not. Fun fact: sheep actually love being shaved. We’ve not been able to converse with them but we imagine they get the same joy from a shave as we do from a good haircut.</p>


      <h4>What’s the difference between normal cotton and organic cotton?</h4>

      <p>The cotton trade is a dangerous one. The industry, quite literally, grows on toxicity. Chemicals are used in production, farmers ingest the chemicals and their health suffers the consequences. It’s not a profitable one either. With no profit and a lack of good health, the suicide rate is at an all time high – ten cotton-related suicides a day in India. </p>

      <p>Organic cotton means no toxicity. That goes for all definitions of the word. It currently makes up 1.5% of the entire cotton industry globally. We’d like to make this the new normal which is why organic cotton is the only cotton we’ll ever use.</p>


      <h4>What’s GOTS-certified?</h4>

      <p>GOTS stands for Global Organic Textiles Standard. They’re essentially the police for our industry and we have their tick of approval – meaning we care about thoughtful creation and we have the accreditation to prove it. </p>


      <h4>What does the future look like?</h4>

      <p>Great question. We are working towards making Paire a carbon-negative brand. This means we’ll invest back into the farms we work with via biodiversity projects. Together, we’ll mitigate the carbon-dioxide impact of your socks (and the Merino wool that goes into them) making us a plus plus plus for the planet. </p>
         </div>
         </section>
      </Layout>

      <Footer />
    </>
  );
};

export default FAQsPage;
